document.addEventListener('DOMContentLoaded', function() {
  // Handle tag scrolling on mobile
  const tagContainer = document.querySelector('.custom-blog__tags-container');
  
  if (tagContainer) {
    // Scroll to the selected tag if exists
    const selectedTag = tagContainer.querySelector('.custom-blog__tag--selected');
    
    if (selectedTag) {
      setTimeout(() => {
        // Scroll the container to center the selected tag
        const containerWidth = tagContainer.offsetWidth;
        const tagPosition = selectedTag.offsetLeft;
        const tagWidth = selectedTag.offsetWidth;
        
        // Center position
        const scrollPosition = tagPosition - (containerWidth / 2) + (tagWidth / 2);
        
        tagContainer.scrollLeft = Math.max(0, scrollPosition);
      }, 100);
    }
  }
  
  // Simple lazy loading for images
  const articleImages = document.querySelectorAll('.custom-blog__article-image');
  
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          const src = img.getAttribute('data-src');
          
          if (src) {
            img.src = src;
            img.removeAttribute('data-src');
          }
          
          observer.unobserve(img);
        }
      });
    });
    
    articleImages.forEach(img => {
      if (img.getAttribute('data-src')) {
        imageObserver.observe(img);
      }
    });
  } else {
    // Fallback for browsers that don't support IntersectionObserver
    articleImages.forEach(img => {
      const src = img.getAttribute('data-src');
      if (src) {
        img.src = src;
        img.removeAttribute('data-src');
      }
    });
  }
});
